import useSWR from 'swr';
import { restaurantTags } from '@/clients/customer/tags';
import { RestaurantTagsResponse } from '@/lib/types/customer/RestaurantTags';

type UseRestaurantTagsOptions = {
  params?: {
    per_page?: number;
    order_dir?: 'asc' | 'desc';
    order_by?: string;
    restaurant_type?: string;
  };
  locale?: string;
  enabled?: boolean;
};

const fetcher = async (
  params: any,
  locale: string
): Promise<RestaurantTagsResponse> => {
  const response = await restaurantTags(params, {
    'Accept-Language': locale,
  });
  return response.data;
};

export default function useRestaurantTags({
  params = {},
  locale = 'en',
  enabled = true,
}: UseRestaurantTagsOptions = {}) {
  const { data, error, isLoading, mutate } = useSWR<RestaurantTagsResponse>(
    enabled ? ['restaurant-tags', params, locale] : null,
    ([, filterParams, lang]: [string, any, string]) =>
      fetcher(filterParams, lang),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      // Keep data fresh for 60 seconds (matching server-side cache)
      dedupingInterval: 60000,
    }
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
}
